export const FeaturesFlags = {
	SCOPELY_LOGIN: "scopely_login_enabled",
	CLUB_SHOP: "club_shop_enabled",
	CLUB_SHOP_FREE_GIFT: "club_shop_free_gift_enabled",
	MERCH_SHOP: "merch_shop_enabled",
	NEWS: "news_enabled",
	DAILY_BONUS: "daily_bonus_enabled",
	WINNERS: "winners_tab_enabled",
	WATERFALL_SALES: "waterfall_sales_enabled",
	STICKY_DIPS: "sticky_dips_enabled",
	CLUB_GIFT_BONUS: "club_gift_bonus_enabled",
	CLUB_GIFT_FIRST_CONTRIBUTION_REWARD: "cgg_first_contribution_reward_enabled",
	DIPS: "dips_enabled",
	/** @deprecated Use POIS_BOUNTY_V2 instead. */
	POIS_BOUNTY: "pois_bounty_enabled",
	POIS_BOUNTY_V2: "pois_bounty_v2_enabled",
	BOGO: "bogo_enabled",
	BOGO_VALIDATION: "bogo_validation_enabled",
	STICKY_TAG: "sale_tags_enabled",
	PWA: "pwa_enabled",
	MAINTENANCE_MODE: "maintenance_mode",
	ENDLESS_OFFER: "endless_offer_enabled",
	FIRST_PURCHASE_BONUS: "first_purchase_bonus_enabled",
	DRIP_OFFER: "drip_offer_enabled",
	BOUNCY_CHEST: "bouncy_chest_enabled",
	HUD_LIMITED_DEALS: "hud_limited_deals_enabled",
	UI_V2: "ui_v2_enabled",
	FEATURED_SECTION_V2: "featured_section_v2_enabled",
	SCOPELY_CONNECT: "scopely_connect_enabled",
	SUPPRESS_WELCOME_GIFT_POPUP: "suppress_welcome_gift_popup",
	REBATE: "rebate_enabled",
	LOYALTY_SHOP_CAROUSEL: "loyalty_shop_carousel_enabled",
	LOYALTY_SHOP_FTUE: "loyalty_shop_ftue_enabled",
	PUSH_NOTIFICATIONS: "push_notifications_enabled",
	FRIEND_CENTER: "friend_center_enabled",
	FRIEND_SHOP: "friend_shop_enabled",
	FRIEND_REFERRAL: "friend_referral_enabled",
	OUTDATED_VERSION_HANDLING: "outdated_version_handling_enabled",
	ELITE: "elite_enabled",
	CHARGEBACK_REFUND_FILTER: "chargeback_refund_filter_enabled",
	FTUE_V2: "ftue_v2_enabled"
};
